export function setCookie(name: string, value: string, expDateTime?: Date, secure: boolean = false): void {
   let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/`;

   if (expDateTime) {
      cookieString += `; expires=${expDateTime.toUTCString()}`;
   }

   if (secure) {
      cookieString += "; secure";
   }

   document.cookie = cookieString;
}

/** The cookie's value, or "" when it is not set — never undefined, so callers can test it as a string. */
export function getCookie(name: string): string {
   const cookies = document.cookie.split(";");

   for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split("=");

      if (cookieName === encodeURIComponent(name)) {
         return decodeURIComponent(cookieValue);
      }
   }

   return "";
}

export function deleteCookie(name: string): void {
   // Set the expiration date to the past
   document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}